













































































































































































































































import { Vue, Component } from 'vue-property-decorator';
import VueToExcel from 'vue-json-excel';
import { VbPagination } from '@/shared/pagination/pagination.component.vue';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import { VbTooltipSlot } from '@/shared/slots/tooltip-slot.component.vue';
import EventBus, { Event } from '@/event.bus';
import DateHandler from '@/shared/utils/date-format';
import splitContent from '@/shared/directive/split-content';
import toDocument from '@/shared/directive/toDocument';
import toCurrency from '@/shared/directive/toCurrency';
import ModalWarning from '@/shared/modal/modal-warning.component.vue';
import ModalComponent from '@/shared/modal/modal.component.vue';
import BillingModalError from '@/shared/billing-error/billing-modal-error.component.vue';
import ModalSuccess from '@/shared/modal/modal-success.component.vue';
import ContractNotBilledModal from '@/views/contract/contract-not-billed/contract-not-billed-modal.component.vue';
import routeTo from '@/router/routeTo'
import AuthorityService from '@/domain/security/authority.service';
import { BillingStatus as BillingStatusFilter } from '@/domain/billing/entity/billing-status.enum';
import { BillingInvoiceReportType } from '@/domain/billing/entity/billing-invoice-report-type.enum';
import TaskService from '@/domain/task/task.service';
import ModalOptions from '@/shared/modal/modal-options.entity';
import DownloadFileBlob from '@/shared/utils/download-file-blob';
import DraggableDataTable from '@/components/DraggableDataTable.vue';
import AuthenticationService from '@/domain/security/authentication.service';
import BillingFilter from '@/domain/billing/entity/billing-filter.entity';
import BillingListSimplified from '@/domain/billing/entity/billing-list-simplified.entity';
import BillingListBase from '@/domain/billing/entity/billing-list-base.entity';
import BillingFilterRequest from '@/domain/billing/request/billing-filter-request.entity';
import BusinessUnit from '@/domain/business-unit/entity/business-unit.entity';
import BillingList from '@/domain/billing/entity/billing-list.entity';
import BillingService from '@/domain/billing/service/billing.service';
import Pagination from '@/domain/pagination.entity';
import UserBusinessUnitService from '@/domain/business-unit/service/business-unit.store';
import Header from './header.json';
import FilterComponent from './billing-filter.component.vue';
import FilterTitleComponent from './billing-filter-title.component.vue';
import ExecuteBillingModal from '../billing-modal/billing-modal-execute.component.vue';
import BillingInfo from '../billing-info/billing-info.component.vue';
import BillableItems from '../billing-modal/billable-items/billable-items-modal.component.vue';
import BillingModalAuditCustomers from '../billing-modal/billling-modal-audit-customers/billing-modal-audit-customers.component.vue';
import BillingModalInvoice from '../billing-modal/billing-modal-invoice.component.vue';
import BillingDataRow from './billing-datarow.component.vue';
import BillingDatatableUtils from './billing-datatable-utils';

const MODAL_STATUS = ['ERROR', 'TO_BILL'];

@Component({
  name: 'BillingDataTable',
  components: {
    VbPagination,
    FilterComponent,
    VbTooltipSlot,
    FilterTitleComponent,
    ExecuteBillingModal,
    BillingInfo,
    ModalWarning,
    ModalSuccess,
    BillingModalError,
    BillableItems,
    VueToExcel,
    ContractNotBilledModal,
    ModalComponent,
    BillingModalAuditCustomers,
    BillingModalInvoice,
    DraggableDataTable,
    BillingDataRow,
  },
  filters: {
    formatDate(value: string) {
      return DateHandler.timestampToLocal(value);
    },
    convertDate(value: string) {
      return DateHandler.fullMonthAndYear(value);
    },
    toCurrency,
    toDocument,
    splitContent,
  },
})

export default class BillingDataTable extends Vue {
  showFilter: boolean = false;

  header: any[] = Header;

  headerDefault: any[] = Header;

  draggableTableKey: number = 0;

  filter: BillingFilter = new BillingFilter({});

  businessUnitId: string = '';

  showExecuteBillingModal: boolean = false;

  executeBillingModalKey: number = 10;

  businessUnitName: string = '';

  selectedBilling: BillingList = BillingList.of();

  warningModal: boolean = false;

  warningModalDeleteAllSelected: boolean = false;

  showSuccessLog: boolean = false;

  warningMessage: string = '';

  warningMessageDeleteAllSelected: string = '';

  messageWaitingProcessDeleteAllSelected: string = '';

  messageNoneSelectedItem: string = '';

  deleteBillingId: string = '';

  competenceSuccess: string = '';

  showBillingModalError: boolean = false;

  showContractNotBilled: boolean = false;

  showBillableItemsModal: boolean = false;

  showCustomerAudit: boolean = false;

  showReportInvoiceModal: boolean = false;

  modalPreviouslyOpened: boolean = false;

  executionError: boolean = false;

  selectedAllBilling: boolean = false;

  pagination: Pagination = new Pagination({
    page: 0,
    itemsPerPage: 10,
    sortBy: [],
    defaultSort: 'competence|desc',
  });

  successMessage = 'Execução realizada com sucesso.'

  billings: BillingListBase[] = [];

  loading: boolean = true;

  searching: boolean = false;

  xlsFields: any = {};

  currencyFormat: any = toCurrency;

  userLoggedInAuthorities!: string[];

  isAdministrator: boolean = false;

  urlCompetence: string = '';

  userEmail: string = '';

  headerUtils: BillingDatatableUtils = new BillingDatatableUtils();

  customSort(items) {
    return items
  }

  goToBillingInfoView(item: BillingListBase): void {
    if (item.deleted) return;
    const route: any = {
      name: 'FaturamentoInfo',
      params: {
        billingId: item.id,
        businessUnitId: this.businessUnitId,
      },
    };
    routeTo(this.$router, route)
  }

  updateExecuteBillingModalState(value: boolean): void {
    if (value) {
      this.executeBillingModalKey += 1;
    }
    this.showExecuteBillingModal = value;
  }

  handleExecutionError() {
    this.showBillingModalError = true;
    this.executionError = true;
  }

  checkAndApplyUrlFilter(): void {
    let {
      status, netValueOperator, netValue, discountedValueOperator, discountedValue,
    } = this.$route.params;
    if (status && status.toUpperCase() === BillingStatusFilter.DISCOUNTED) {
      status = BillingStatusFilter.BILLED;
      discountedValueOperator = 'GREATER_THAN';
      discountedValue = 0.01.toLocaleString();
    }

    if (status && (status.toUpperCase() === BillingStatusFilter.INVOICE_ZERO_VALUE)) {
      status = BillingStatusFilter.PRE_INVOICE;
      netValueOperator = 'EQUAL';
      netValue = 0.00.toLocaleString();
    }
    if (status && (status.toUpperCase() === BillingStatusFilter.INVOICE_HAS_VALUE)) {
      status = BillingStatusFilter.PRE_INVOICE;
      netValueOperator = 'GREATER_THAN';
      netValue = 0.01.toLocaleString();
    }

    if (
      (status || this.$route.params.competence || this.$route.query.contractId)
      && !MODAL_STATUS.includes(status)
    ) {
      const competence = this.$route.params.competence
        ? DateHandler.localDateToLocal(this.$route.params.competence)
        : null;
      const filter: BillingFilter = new BillingFilter(
        {
          status: status ? status.toUpperCase() : null,
          competence,
          discountedValueOperator,
          discountedValue,
          netValueOperator,
          netValue,
          contractExternalId: this.$route.query.contractId,
        },
      );
      this.applyFilter(filter);
    }
  }

  checkAndOpenModalError(): void {
    if (this.$route.params.status === 'ERROR') {
      this.showBillingModalError = true;
      this.modalPreviouslyOpened = true;
    }
  }

  checkAndOpenModalToBill(): void {
    if (this.$route.params.status === 'TO_BILL') {
      this.showBillableItemsModal = true;
      this.modalPreviouslyOpened = true;
    }
  }

  setDeleteBillingId(deleteBillingId: string): void {
    this.deleteBillingId = deleteBillingId;
  }

  openWarningModal(): void {
    this.warningModal = true;
    this.warningMessage = 'Deseja realmente <strong style="color: orange">remover</strong> o faturamento? '
    + 'Ao clicar no botão Sim, as alterações serão imediatamente realizadas.';
  }

  openWarningModalDeleteAllSelected(): void {
    this.warningModalDeleteAllSelected = true;
    this.warningMessageDeleteAllSelected = 'Deseja realmente <strong style="color: orange">remover</strong> os faturamentos selecionados? '
    + 'Ao clicar no botão Sim, as alterações serão imediatamente realizadas.';
  }

  openModalNoneSelectedItem(): void {
    this.messageNoneSelectedItem = 'Para remover os registros selecionados'
      + ' pelo menos um deles deve estar marcado!'
  }

  confirm(): void {
    this.deleteBilling(this.businessUnitId, this.deleteBillingId);
    this.closeWarningModal();
  }

  confirmDeleteAllSelected(): void {
    this.loading = true;
    const listBillingId = this.billings
      .filter((item: BillingListBase) => !!item.selected)
      .map((it) => it.id);
    this.closeWarningModalDeleteAllSelected();
    this.messageWaitingProcessDeleteAllSelected = `Aguarde até que os ${listBillingId.length}
      registros selecionados sejam removidos!`;

    BillingService.deleteAllSelectedBilling(this.businessUnitId, listBillingId)
      .then((taskId : string) => this.handleAfterExecuteDeleteAllSelectedBilling(taskId))
      .catch((err: any) => {
        this.handleAfterErrorExecuteDeleteAllSelectedBilling(err);
      });
  }

  handleAfterErrorExecuteDeleteAllSelectedBilling(err: any) {
    this.messageWaitingProcessDeleteAllSelected = '';
    this.loading = false;
    VbSnackbarService.handleHttpError(err);
  }

  handleCloseModalNoneSelectedItem(): void {
    this.messageNoneSelectedItem = '';
  }

  handleAfterExecuteDeleteAllSelectedBilling(taskId: string) {
    TaskService.getTask(taskId, 10000)
      .then(() => {
        this.messageWaitingProcessDeleteAllSelected = '';
        this.loading = false;
        this.selectedAllBilling = false;
        this.findBillings();
      })
      .catch((err) => this.handleAfterErrorExecuteDeleteAllSelectedBilling(err));
  }

  confirmSuccess(): void {
    this.closeSuccessLog();
  }

  closeSuccessLog(): void {
    this.showSuccessLog = false;
  }

  closeWarningModal(): void {
    this.warningModal = false;
  }

  closeWarningModalDeleteAllSelected(): void {
    this.warningModalDeleteAllSelected = false;
  }

  removeButtonTooltipText(item: BillingList): string {
    if (!this.isAdministrator) {
      return 'Você não tem permissão para remover um faturamento'
    }
    if (item.isPreInvoice) {
      return 'Remover faturamento'
    }
    return 'Só é possível remover faturamentos com status Pré-Faturado';
  }

  deleteBilling(businessUnitId: string, deleteBillingId: string): void {
    BillingService.deleteBilling(businessUnitId, deleteBillingId)
      .then(() => {
        this.findBillings();
      })
      .catch((err: any) => VbSnackbarService.handleHttpError(err))
      .finally(() => {
        this.setDeleteBillingId('');
      })
  }

  loadHeaders(): void {
    this.headerUtils = new BillingDatatableUtils();
    this.headerUtils.loadHeaders();
    this.header = [...this.headerUtils.headerSelected];
  }

  created() {
    this.loadHeaders();
    this.getUserLoggedInAuthorities();
    this.checkAndApplyUrlFilter();
    this.userEmail = AuthenticationService.userLoggedIn().email;
    this.businessUnitId = UserBusinessUnitService.currentBusinessUnit.id;
    this.businessUnitName = UserBusinessUnitService.currentBusinessUnit.name;
    this.urlCompetence = this.$route.params.competence;
    if (this.businessUnitId) {
      EventBus.$off(Event.BUSINESS_UNIT_SELECTED);
    }
    EventBus.$on(Event.BUSINESS_UNIT_SELECTED, (businessUnit: BusinessUnit) => {
      if (this.$route.name && (this.$route.name.includes('Faturamento') || this.$route.name.includes('BillingDataTable'))) {
        this.businessUnitId = businessUnit.id;
        this.businessUnitName = businessUnit.name;
        this.pagination.page = 1
        this.findBillings();
        if (!this.modalPreviouslyOpened) {
          this.checkAndOpenModalError();
          this.checkAndOpenModalToBill();
        }
      }
    });
    this.findBillings();
  }

  applyFilter(filter: BillingFilter) {
    this.filter = BillingFilter.of(filter);
    this.pagination.page = 1;
    this.findBillings();
  }

  removeAllSelected() {
    const totalSelected = this.billings.filter(
      (item: BillingListBase) => item.selected,
    ).length > 0;
    if (totalSelected) {
      this.openWarningModalDeleteAllSelected();
    } else {
      this.openModalNoneSelectedItem();
    }
  }

  handleExecutionSuccess(competence: string) {
    this.competenceSuccess = competence;
    this.showSuccessLog = true;
  }

  filterByCompetence(): void {
    const competence = this.competenceSuccess
    const filter: BillingFilter = BillingFilter.of({ competence });
    this.applyFilter(filter);
    this.closeSuccessLog();
  }

  private get isSimplifiedRequest(): boolean {
    return this.activeHeaders.every((it) => it.value !== 'discountDiscountValueJoined');
  }

  findBillings() {
    if (this.searching === true) {
      return;
    }

    if (this.businessUnitId) {
      const requestFilter: BillingFilterRequest = BillingFilterRequest.of(this.filter);
      this.loading = true;
      this.searching = true;

      if (this.isSimplifiedRequest) {
        BillingService.getAllSimplifiedPost(this.businessUnitId, requestFilter, this.pagination)
          .then((response: any) => {
            this.billings = response.content.map((it) => new BillingListSimplified(it));
            this.pagination.total = response.totalElements;
            this.pagination.pageCount = response.totalPages;
            this.selectedAllBilling = false;
          })
          .catch((err: any) => VbSnackbarService.handleHttpError(err))
          .finally(() => {
            this.loading = false;
            this.searching = false;
          });
        return;
      }
      BillingService.getAllPost(this.businessUnitId, requestFilter, this.pagination)
        .then((response: any) => {
          this.billings = BillingList.ofList(response.content);
          this.pagination.total = response.totalElements;
          this.pagination.pageCount = response.totalPages;
          this.selectedAllBilling = false;
        })
        .catch((err: any) => VbSnackbarService.handleHttpError(err))
        .finally(() => {
          this.loading = false;
          this.searching = false;
        });
    }
  }

  updateSortBy(sorted: any) {
    this.pagination.sortBy = [sorted.sortBy];
    this.pagination.sortDesc = [sorted.sortDesc];
    this.updateTable();
  }

  saveHeaders(header: any) {
    this.header = [...header];
    this.saveLocalStorage();
  }

  saveLocalStorage() {
    const newOrder = this.header.map((it) => it.value);
    this.headerUtils.saveHeaders(newOrder);
    this.updateTable();
  }

  updateTable() {
    this.draggableTableKey += 1;
    this.pagination.verifyPage();
    this.loadHeaders();
    this.findBillings();
  }

  updateSelectedAllBilling() {
    this.billings.forEach((item: BillingListBase) => {
      if (item.isPreInvoice) {
        item.selected = this.selectedAllBilling;
      }
    });
  }

  get activeHeaders(): any[] {
    return this.header;
  }

  updateColumnState(newHeaderArr: any[]) {
    const reorder: any[] = [];
    newHeaderArr.forEach((h: string) => {
      const found = this.headerDefault.find((hd) => hd.value === h);
      if (found) {
        found.active = true;
        reorder.push(found);
      }
    });
    this.saveHeaders(reorder);
  }

  setXlsFields(): void {
    this.xlsFields = { 'Nº Nota Fiscal': 'invoiceNumber' };
    const activeHeaders: string[] = this.activeHeaders.map((header) => header.text);
    if (activeHeaders.includes('CONTRATO')) {
      this.xlsFields.Contrato = 'contractsJoined';
    }
    if (activeHeaders.includes('ITENS')) {
      this.xlsFields.Itens = 'itemsGrouped';
    }
    this.xlsFields['Cód. Cliente'] = 'customerExternalId';
    if (activeHeaders.includes('NOME FANTASIA')) {
      this.xlsFields['Nome Fantasia'] = 'customerTradingName';
    }
    this.xlsFields.Cliente = 'customerName';
    this.xlsFields['CPF/CNPJ'] = 'customerDocument';
    this.xlsFields['Beneficiário'] = 'beneficiariesJoined';
    this.xlsFields['Centro de Resultado'] = 'resultCentersJoined';
    this.xlsFields['ID de Contas a Receber'] = 'invoicePaymentsJoined';
    this.xlsFields['Competência'] = 'competence';
    this.xlsFields.Vencimento = 'paymentDueAt';
    this.xlsFields.Status = 'status.description';
    this.xlsFields['Valor Líquido'] = 'netValue';
    this.xlsFields['Valor Nota'] = 'invoiceValue';
    if (activeHeaders.includes('VALOR RECEBIDO')) {
      this.xlsFields['Valor Recebido'] = 'paymentPaidValue';
    }
    if (activeHeaders.includes('VALOR A RECEBER')) {
      this.xlsFields['Valor a Receber'] = 'paymentOpenValue';
    }
    this.xlsFields['Observações'] = 'observations';
    this.xlsFields['Tipo do Desconto'] = 'discountDiscountTypeJoined';
    if (activeHeaders.includes('VALOR DO DESCONTO')) {
      this.xlsFields['Valor de Desconto'] = 'discountDiscountValueJoined';
    }
    this.xlsFields['Responsável'] = 'discountResponsibleJoined';
    this.xlsFields['Obs. Desconto'] = 'discountObservationJoined';
    this.xlsFields['Justificativa Desconto'] = 'discountJustificationJoined';
    if (activeHeaders.includes('VALOR NOTA MOEDA ORIGINAL')) {
      this.xlsFields['Valor Nota Moeda Original'] = 'unexchangedValue';
    }
    if (activeHeaders.includes('VALOR PAGO MOEDA ORIGINAL')) {
      this.xlsFields['Valor Pago Moeda Original'] = 'unexchangedPaidValue';
    }
    this.xlsFields['Moeda Original'] = 'currencyFrom.name';
  }

  exportToXLS(): Promise<BillingList[] | BillingListSimplified[]> {
    const requestFilter: BillingFilterRequest = BillingFilterRequest.of(this.filter);
    const pagination: Pagination = new Pagination({
      ...this.pagination,
      itemsPerPage: this.pagination.total,
    });

    if (this.isSimplifiedRequest) {
      return BillingService.getAllSimplifiedPost(this.businessUnitId, requestFilter, pagination)
        .then((response: any) => {
          const content: any[] = response.content.map((item) => ({
            ...item,
            customerDocument: toDocument(item.customerDocument),
          }));
          return content.map((it) => new BillingListSimplified(it));
        });
    }
    return BillingService.getAllPost(this.businessUnitId, requestFilter, pagination)
      .then((response: any) => {
        const content: any[] = response.content.map((item) => ({
          ...item,
          customerDocument: toDocument(item.customerDocument),
        }));
        return BillingList.ofList(content);
      });
  }

  exportToEmail(): void {
    const requestFilter: BillingFilterRequest = BillingFilterRequest.of(this.filter);
    const pagination: Pagination = new Pagination({
      ...this.pagination,
      itemsPerPage: this.pagination.total,
    });
    BillingService.exportToEmailPost(
      this.businessUnitId,
      this.userEmail,
      requestFilter,
      pagination,
    );
  }

  downloadPersonalityBancoBrasil() {
    this.downloadFilePersonality(BillingInvoiceReportType.BANCO_BRASIL);
  }

  exportToEmailPersonalityBancoBrasil() {
    this.exportToEmailPersonality(BillingInvoiceReportType.BANCO_BRASIL);
  }

  validatePersonalityItau(): boolean {
    // if (!this.filter.competence
    // || this.filter.competence === null || this.filter.competence.trim() === '') {
    //   console.log('competence', this.filter);
    //   VbSnackbarService.showError('Necessário selecionar a Competência');
    //   return false;
    // }
    // if (!this.filter.invoiceNumber
    // || this.filter.invoiceNumber === null || this.filter.invoiceNumber.trim() === '') {
    //   VbSnackbarService.showError('Necessário informar a Nota Fiscal');
    //   return false;
    // }
    return true;
  }

  downloadPersonalityItau() {
    if (this.validatePersonalityItau()) {
      this.downloadFilePersonality(BillingInvoiceReportType.ITAU);
    }
  }

  exportToEmailPersonalityItau() {
    if (this.validatePersonalityItau()) {
      this.exportToEmailPersonality(BillingInvoiceReportType.ITAU);
    }
  }

  validatePersonalitySantander(): boolean {
    // if (!this.filter.invoiceNumber
    // || this.filter.invoiceNumber === null || this.filter.invoiceNumber.trim() === '') {
    //   VbSnackbarService.showError('Necessário informar a Nota Fiscal');
    //   return false;
    // }
    return true;
  }

  downloadPersonalitySantander() {
    if (this.validatePersonalitySantander()) {
      this.downloadFilePersonality(BillingInvoiceReportType.SANTANDER);
    }
  }

  exportToEmailPersonalitySantander() {
    if (this.validatePersonalitySantander()) {
      this.exportToEmailPersonality(BillingInvoiceReportType.SANTANDER);
    }
  }

  validatePersonalityBradesco(): boolean {
    // if (!this.filter.invoiceNumber
    // || this.filter.invoiceNumber === null || this.filter.invoiceNumber.trim() === '') {
    //   VbSnackbarService.showError('Necessário informar a Nota Fiscal');
    //   return false;
    // }
    return true;
  }

  downloadPersonalityBradesco() {
    if (this.validatePersonalityBradesco()) {
      this.downloadFilePersonality(BillingInvoiceReportType.BRADESCO);
    }
  }

  exportToEmailPersonalityBradesco() {
    if (this.validatePersonalityBradesco()) {
      this.exportToEmailPersonality(BillingInvoiceReportType.BRADESCO);
    }
  }

  downloadFilePersonality(reportType: string): void {
    const requestFilter: BillingFilterRequest = BillingFilterRequest.of(this.filter);
    const pagination: Pagination = new Pagination({
      ...this.pagination,
      itemsPerPage: this.pagination.total,
    });
    BillingService.downloadFilePost(this.businessUnitId, requestFilter, pagination, reportType)
      .then((response) => {
        if (response && response.status && response.status !== 200) {
          VbSnackbarService.handleHttpError(response.data);
          return;
        }
        DownloadFileBlob.download(
          `relatorio-faturamento-${reportType}.xls`,
          `data:application/msexcel;base64,${response}`,
        );
      })
      .catch((err: any) => {
        VbSnackbarService.handleHttpError(err)
      });
  }

  exportToEmailPersonality(reportType: string): void {
    const requestFilter: BillingFilterRequest = BillingFilterRequest.of(this.filter);
    const pagination: Pagination = new Pagination({
      ...this.pagination,
      itemsPerPage: this.pagination.total,
    });
    BillingService.exportToEmailPost(
      this.businessUnitId,
      this.userEmail,
      requestFilter,
      pagination,
      reportType,
    );
  }

  getUserLoggedInAuthorities() {
    AuthorityService.authorities().then((resp) => {
      this.userLoggedInAuthorities = resp;
      this.isAdministrator = this.userLoggedInAuthorities.includes('ADMINISTRATOR');
    })
  }

  optionsModalWaitingDeleteAll(descriptionValue: string): ModalOptions {
    return {
      title: 'Atenção',
      titleSize: '20px',
      titleAlign: 'left',
      showClose: false,
      description: descriptionValue || '',
      showOk: false,
      showCancel: false,
      width: 500,
      persistent: false,
    }
  }

  optionsModalNoneSelectedItem(descriptionValue: string): ModalOptions {
    return {
      title: 'Atenção',
      titleSize: '20px',
      titleAlign: 'left',
      showClose: false,
      description: descriptionValue,
      showOk: true,
      labelOk: 'Entendi',
      showCancel: false,
      width: 500,
      persistent: false,
    }
  }
}

